import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  Box: {
    width: '400px',
    background: 'var(--Base-White, #FFF)',
    borderRadius: '12px',
    boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
  },
  BoxHeader: {
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
    background: 'var(--Base-White, #FFF)',
  },
  BoxContent: {
    display: 'flex',
    padding: '0px 16px',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
  },
  BoxFooter: {
    display: 'flex',
    padding: ' 24px 16px 16px 16px',
    alignItems: 'flex-start',
    gap: '12px',
    flex: '1 0 0',
  },
  BoxTitleModal: {
    borderRadius: '12px',
    display: 'flex',
    padding: ' 20px 16px 16px 16px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
    background: 'var(--Base-White, #FFF)',
    alignSelf: 'stretch',
  },
  TitleModal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignSelf: 'stretch',
  },
  DeleteIcon: {
    display: 'flex',
    width: '48px',
    height: '48px',
    padding: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '28px',
    border: '8px solid var(--Error-50, #FEF3F2)',
    background: 'var(--Error-100, #FEE4E2)',
  },
  Icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
  },
}));

const cancelButtonStyle = {
  display: 'flex',
  padding: '12px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  flex: '1 0 0',
  borderRadius: '8px',
  border: '1px solid var(--Gray-300, #D0D5DD)',
  background: 'var(--Base-White, #FFF)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: '#FFF' },
};

const confirmButtonStyle = {
  display: 'flex',
  padding: '12px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  flex: '1 0 0',
  borderRadius: '8px',
  border: '1px solid var(--Error-600, #D92D20)',
  background: 'var(--Error-600, #D92D20)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: '#D92D20' },
};

export { useStyles, cancelButtonStyle, confirmButtonStyle };
